/* Built In Imports */

/* External Imports */
import { Box, Heading, Image, Text } from '@chakra-ui/react';
import { render } from 'datocms-structured-text-to-html-string';
import Slider from 'react-slick';

/* Components */
import MsrSectionTitle from '@msr/components/Headings/MsrSectionTitle';

/* Internal Imports */
import FaqSectionV3 from '../Accordions/FaqSectionV3';
/* Services */

/**
 * Renders the Card Info 1 Card component
 * @param {Object} sectionContent - Data for section
 * @returns {ReactElement} CardGrid Card component
 */
const MSRFaqSectionV3 = ({ sectionContent, lang, region }) => {
  return (
    <Box mx="auto" w="full" marginBottom={"100px"}>
      <Box m="30px auto 0 auto" pb="20px" >
        <MsrSectionTitle
          pt="0"
          mt="0"
          fontSize="34px"
          titleObj={sectionContent[0]}
          w={{
            base: 'auto',
            md: '515px',
            lg: '900px',
          }}
          maxwidth={'900px'}
        />
      </Box>
      <FaqSectionV3
        faqSection={sectionContent}
        region={region}
        lang={lang}
      />
    </Box>
  );
};

export default MSRFaqSectionV3;
